import React, { createContext, useState, useContext } from "react";

const PlayContext = createContext();

export default function PlayProvider({ children }) {
  const [prizeNumber, setPrizeNumber] = useState(0);
  const data = [];
  return (
    <PlayContext.Provider value={{ prizeNumber, setPrizeNumber, data }}>
      {children}
    </PlayContext.Provider>
  );
}

export function usePlay() {
  const context = useContext(PlayContext);
  const { prizeNumber, setPrizeNumber } = context;
  const data = [
    { id: 0, option: 0 },
    { id: 1, option: 1 },
    { id: 2, option: 2 },
    { id: 3, option: 3 },
    { id: 4, option: 4 },
    { id: 5, option: 5 },
    { id: 6, option: 6 },
    { id: 7, option: 7 },
    { id: 8, option: 8 },
    { id: 9, option: 9 },
    { id: 10, option: 10 },
    { id: 11, option: 11 },
    { id: 12, option: 12 },
    { id: 13, option: 13 },
    { id: 14, option: 14 },
    { id: 15, option: 15 },
    { id: 16, option: 16 },
    { id: 17, option: 17 },
    { id: 18, option: 18 },

    { id: 19, option: 19 },
    { id: 20, option: 20 },
    { id: 21, option: 21 },
    { id: 22, option: 22 },
    { id: 23, option: 23 },
    { id: 24, option: 24 },
    { id: 25, option: 25 },
    { id: 26, option: 26 },
    { id: 27, option: 27 },
    { id: 28, option: 28 },
    { id: 29, option: 29 },
    { id: 30, option: 30 },
    { id: 31, option: 31 },
    { id: 32, option: 32 },
    { id: 33, option: 33 },
    { id: 34, option: 34 },
    { id: 35, option: 35 },
    { id: 36, option: 36 },
    { id: 37, option: "00" }
  ];

  return { prizeNumber, setPrizeNumber, data };
}
